import { render } from "./SalesPage.vue?vue&type=template&id=285648a3&ts=true"
import script from "./SalesPage.vue?vue&type=script&lang=ts"
export * from "./SalesPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__